<template>
<div id="apptable" v-cloak>

    <b-card :header="'Rispsote questionario #' + this.$route.params.id + ' ' + this.$route.params.titolo" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>                
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="domanda" scope="row">{{row.value}}</template>
                <template slot="risposta" scope="row">{{row.value}}</template>
                <template slot="voto" scope="row">{{row.value}}</template>
                <template slot="tipologia" scope="row">{{row.value}}</template>
                <template slot="ordinamento" scope="row">{{row.value}}</template>
            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>
    
</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                domanda: {
                    label: 'Domanda',
                    sortable: true
                },
                risposta: {
                    label: 'Risposta',
                    sortable: true
                },      
                voto: {
                    label: 'Voto',
                    sortable: true
                },        
                tipologia: {
                    label: 'Tipo domanda',
                    sortable: true
                }, 
                ordinamento: {
                    label: 'Ordinamento',
                    sortable: true
                },              
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },            
            id_questionariodomande: this.$route.params.id || null,            
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 5,
                value: 5
            }, {
                text: 10,
                value: 10
            }, {
                text: 15,
                value: 15
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,            
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {       
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    },
    created: function () {   
        
        if(!ctrlVismenu("E")){
            this.$router.replace('/accessdenied');
            return;
        }     
        
        var id_questionariodomande = this.id_questionariodomande;
        //alert(id_questionariodomande);
        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/rispostedettaglio/idquest/' + id_questionariodomande, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
